import React from 'react';

import '../../assets/css/App.css';
import MainContent from "../../components/mainContent/MainContent";
import TerminoAdminLayout from './components/TerminoAdminLayout';
  
export default function TerminoAdminItem() {

    return (
        <MainContent titulo='Administración Términos y Condiciones' component={ <TerminoAdminLayout /> } />        
    );
  }